import React from "react";
import StatusBar from "@/components/StatusBar";
import Sidebar from "@/components/Sidebar";

const Layout = ({ children, node, session }) => {
  return (
    <div className="min-h-screen">
      <StatusBar node={node} session={session} />
      <div className="flex pt-12">
        <Sidebar />
        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
